import ParallaxScrollingElement from "@/ts/base/Components/ParallaxScrollingElement";

class ParallaxScrollingElementCollection {

	elements: NodeListOf<HTMLElement>;

	collection: ParallaxScrollingElement[] = [];

	constructor(parallaxContainerSelector: string) {
		this.elements = document.querySelectorAll(parallaxContainerSelector);

		if (this.elements.length > 0) {
			this.init();
		}
	}

	init(): void {
		this.elements.forEach(item => {
			this.collection.push(new ParallaxScrollingElement(item));
		});

		this.createIntersectionObserver();
	}

	getItemByElement(element: HTMLElement): ParallaxScrollingElement | null {
		let out: ParallaxScrollingElement | null = null;
		this.collection.forEach(i => {
			if (element.isEqualNode(i.container)) {
				out = i;
				return;
			}
		});
		return out;
	}

	protected createIntersectionObserver(): void {
		const observer = new IntersectionObserver(this.onIntersectionObserve.bind(this),{
			threshold: [0, 1]
		});

		this.elements.forEach(el => {
			observer.observe(el);
		});
	}

	protected onIntersectionObserve(entries: IntersectionObserverEntry[], observer: IntersectionObserver): void {
		entries.forEach(entry => {
			const item = this.getItemByElement(entry.target as HTMLElement);
			if (item instanceof ParallaxScrollingElement) {
				item.isVisible = entry.isIntersecting;
			}
		});
	}

}

export default ParallaxScrollingElementCollection;
